export default "__VITE_ASSET__DNoD$Azj__"